export const PENDING_COURSES: string[] = [];

/** Obscured path segment for civil training URLs, e.g. #/tc/a7x9k2m4p1 */
export const CIVIL_PATH_KEY = 'a7x9k2m4p1';

/** Course ids available under civil training */
export const CIVIL_COURSE_TYPES: string[] = ['general-staff'];

/** Build civil-scoped hash path: /{lang}/{key}/... */
export const civilPath = (language: string, ...segments: string[]) => {
  const rest = segments.filter(Boolean).join('/');
  return rest
    ? `/${language}/${CIVIL_PATH_KEY}/${rest}`
    : `/${language}/${CIVIL_PATH_KEY}`;
};
